'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
function callMeNowController($window, callMeNowService, errorMessagesService) {
    var vm = this;
    vm.showErrorMessages = errorMessagesService.showErrorMessages;
    vm.numberToCall = '';
    vm.toggleAssistentCbFunction = toggleAssistentCbFunction;
    vm.stuurBelVerzoek = stuurBelVerzoek;
    vm.label = '';
    vm.onderwerp = '';
    vm.buttonText = 'Bel me terug';
    vm.image = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='; // 1x1 transparent pixel
    vm.headerLine1 = 'U heeft een vraag?';
    vm.headerLine2 = 'Wij bellen u terug.';
    vm.text = 'Binnen maximaal 5 minuten wordt u door een van onze medewerkers gebeld.';
    vm.inputLabel = 'Uw telefoonnummer';
    vm.validationText = 'Telefoonnummer begint met 0 en bestaat uit 10 cijfers.';

    vm.displayCallMeNow = false;
    vm.displayHeaderLine2 = true;

    function toggleAssistentCbFunction() {
        return {
            open: function open(onderwerp, label) {
                vm.displayCallMeNow = true;
                if (onderwerp) vm.onderwerp = onderwerp;
                if (label) vm.label = label;
            },
            close: function close() {
                vm.displayCallMeNow = false;
            },
            image: function image(url) {
                vm.image = url;
            },
            buttonTekst: function buttonTekst(text) {
                vm.buttonText = text;
            },
            headerLine1: function headerLine1(text) {
                vm.headerLine1 = text;
            },
            headerLine2: function headerLine2(text) {
                vm.displayHeaderLine2 = true;
                vm.headerLine2 = text;
            },
            text: function text(_text) {
                vm.text = _text;
            },
            inputLabel: function inputLabel(text) {
                vm.inputLabel = text;
            },
            validationText: function validationText(text) {
                vm.validationText = text;
            }
        };
    }

    function stuurBelVerzoek(form) {
        if (!formIsDefined(form) || !form.$valid) {
            return;
        }
        vm.error = undefined;
        vm.success = undefined;
        callMeNowService.callMeNow(vm.numberToCall, $window.location.href, vm.label, vm.onderwerp).then(function () {
            vm.numberToCall = '';
            vm.displayCallMeNow = false;
        }).catch(function () {
            vm.error = 'Het verzoek kon niet worden verzonden, probeer het later nog eens.';
        });
    }

    function formIsDefined(form) {
        if (!angular.isDefined(form)) {
            return false;
        }
        form.$setSubmitted();
        return true;
    }
}

callMeNowController.$inject = ['$window', 'callMeNowService', 'errorMessagesService'];

exports.default = callMeNowController;


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/call-me-now/call-me-now.controller.js
// module id = 849
// module chunks = 0